import React from 'react';
import { Button, type ButtonProps } from '@chakra-ui/react';

export type PillButtonVariant = 'primary' | 'primaryLight' | 'secondary' | 'text';

export interface PillButtonProps {
  label: string;
  variant?: PillButtonVariant;
  onPress: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  testID?: string;
}

const variantStyles: Record<PillButtonVariant, ButtonProps> = {
  primary: {
    bg: 'onboarding.plum',
    color: 'onboarding.cream',
    _hover: { bg: 'onboarding.plumSecondary', opacity: 0.95 },
    _active: { opacity: 0.9 },
  },
  primaryLight: {
    bg: 'onboarding.cream',
    color: 'onboarding.plum',
    _hover: { bg: 'onboarding.warmLight', opacity: 0.95 },
    _active: { opacity: 0.9 },
  },
  secondary: {
    bg: 'transparent',
    color: 'onboarding.cream',
    border: '1px solid',
    borderColor: 'onboarding.cream',
    _hover: { bg: 'whiteAlpha.100' },
    _active: { opacity: 0.85 },
  },
  text: {
    bg: 'transparent',
    color: 'onboarding.mutedRose',
    _hover: { bg: 'transparent', textDecoration: 'underline' },
    _active: { opacity: 0.7 },
  },
};

export function PillButton({
  label,
  variant = 'primary',
  onPress,
  disabled = false,
  isLoading = false,
  testID,
}: PillButtonProps) {
  return (
    <Button
      onClick={onPress}
      isDisabled={disabled}
      isLoading={isLoading}
      w="100%"
      maxW="343px"
      h="48px"
      borderRadius="60px"
      fontWeight="600"
      fontSize="16px"
      data-testid={testID}
      {...variantStyles[variant]}
    >
      {label}
    </Button>
  );
}

export default PillButton;
